import { render } from "./FloatEditNewsButton.vue?vue&type=template&id=8717150e&scoped=true"
import script from "./FloatEditNewsButton.vue?vue&type=script&lang=js"
export * from "./FloatEditNewsButton.vue?vue&type=script&lang=js"

import "./FloatEditNewsButton.vue?vue&type=style&index=0&id=8717150e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8717150e"]])

export default __exports__
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPageSticky,QBtn,QTooltip});
